import * as React from "react";

import { ControlReference } from "../../../Engine/Core/ControlDispatcher/ControlReference";
import { IterUtils } from "../../../../../Common/IterableUtils";

import { ITourElementsRegistry } from "./ITourElementsRegistry";

interface ReactRefHolder {
    referenceType: "ReactRef";
    ref: React.RefObject<HTMLElement | React.ReactInstance>;
}

export class TourElementsRegistry implements ITourElementsRegistry {
    private readonly controls: Map<string, Array<ControlReference | ReactRefHolder>> = new Map();

    public registerReactRef(id: string, control: React.RefObject<HTMLElement | React.ReactInstance>): void {
        const normalizedId = id.replace(/\/\*$/g, "");

        if (!this.controls.has(normalizedId)) {
            this.controls.set(normalizedId, []);
        }
        this.controls.get(normalizedId)?.push({ referenceType: "ReactRef", ref: control });
    }

    public unregisterReactRef(id: string, control: React.RefObject<HTMLElement | React.ReactInstance>): void {
        const normalizedId = id.replace(/\/\*$/g, "");

        if (!control) {
            this.controls.set(normalizedId, []);
        }
        const index =
            control == undefined
                ? -1
                : this.controls.get(normalizedId)?.findIndex(x => "referenceType" in x && x.ref === control);

        if (index != undefined && index !== -1) {
            this.controls.get(normalizedId)?.splice(index, 1);
        }
    }

    public registerControl(id: string, control: ControlReference): void {
        const normalizedId = id.replace(/\/\*$/g, "");

        if (!this.controls.has(normalizedId)) {
            this.controls.set(normalizedId, []);
        }
        this.controls.get(normalizedId)?.push(control);
    }

    public unregisterControl(id: string, control: undefined | ControlReference): void {
        const normalizedId = id.replace(/\/\*$/g, "");

        if (!control) {
            this.controls.set(normalizedId, []);
        }
        const index = control == undefined ? -1 : this.controls.get(normalizedId)?.indexOf(control);

        if (index != undefined && index !== -1) {
            this.controls.get(normalizedId)?.splice(index, 1);
        }
    }

    public getLastControl(id: string): undefined | ControlReference {
        return this.toControlReference(IterUtils.last(this.controls.get(id) ?? []));
    }

    private toControlReference(
        controlRef: ControlReference | ReactRefHolder | undefined
    ): ControlReference | undefined {
        if (controlRef == undefined) {
            return undefined;
        }
        if ("referenceType" in controlRef) {
            return controlRef.ref.current ?? undefined;
        }
        return controlRef;
    }
}
